module.exports = __webpack_public_path__ + "7911cc917242499d9a64629ab3f9aa7e.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-54.cur
// module id = 464
// module chunks = 0